import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/auth/callback")({
  head: () => ({ meta: [{ title: "Signing in… — Tiger's Eye" }] }),
  component: AuthCallback,
});

function AuthCallback() {
  const navigate = useNavigate();
  useEffect(() => {
    let cancelled = false;
    const go = async () => {
      const { supabase } = await import("@/integrations/supabase/client");
      // supabase-js auto-handles the hash; just wait for the session.
      const { data } = await supabase.auth.getSession();
      if (cancelled) return;
      if (!data.session) {
        navigate({ to: "/login" });
        return;
      }
      // New users (no preferred name AND no institution set) are sent
      // straight to /profile so the guided setup is the first thing they see.
      try {
        const { data: prof } = await supabase
          .from("profiles")
          .select("preferred_name, institution_id, institution_name")
          .eq("id", data.session.user.id)
          .maybeSingle();
        const hasName = !!(prof?.preferred_name && prof.preferred_name.trim());
        const hasInstitution = !!(prof?.institution_id || prof?.institution_name);
        if (!hasName || !hasInstitution) {
          navigate({ to: "/profile" });
          return;
        }
      } catch {
        /* fall through to dashboard */
      }
      navigate({ to: "/dashboard" });
    };
    void go();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-paper">
      <p className="font-serif text-2xl text-primary">Signing you in…</p>
    </div>
  );
}
